export const variationPropertiesEN = [
  {
    id: 6,
    position: 0,
    name: 'Product properties',
    description: 'Properties for displaying product information',
    properties: [
      {
        cast: 'text',
        referrer: [1],
        names: {
          createdAt: '2024-07-17 16:40:31',
          propertyId: 10,
          name: 'Property Example',
          updatedAt: '2024-07-17 16:40:31',
          description: 'Used to indicate legally required material properties',
          id: 15,
          lang: 'en',
        },
        clients: [67698],
        display: ['showInItemListing', 'showOnItemsPage', 'displayInOrderProcess'],
        groups: [
          {
            options: [
              {
                id: 10,
                updatedAt: '2024-06-10 09:10:33',
                type: 'surchargeType',
                createdAt: '2024-06-10 09:10:33',
                groupId: 6,
                value: 'flat',
              },
              {
                createdAt: '2024-06-10 09:10:33',
                id: 9,
                type: 'groupType',
                groupId: 6,
                value: 'none',
                updatedAt: '2024-06-10 09:10:33',
              },
            ],
            position: 0,
            names: {
              id: 8,
              groupId: 6,
              description: 'Properties for displaying product information',
              name: 'Product properties',
              createdAt: '2024-06-10 09:10:33',
              updatedAt: '2024-06-10 09:10:33',
              lang: 'en',
            },
            updatedAt: '2024-06-10 09:10:33',
            id: 6,
            createdAt: '2024-06-10 09:10:33',
          },
        ],
        id: 10,
        groupId: 6,
        position: 0,
        markup: 0,
        values: {
          id: 2,
          lang: 'en',
          value: 'Example 1',
          description: '',
        },
      },
      {
        cast: 'text',
        referrer: [1],
        names: {
          createdAt: '2024-07-17 16:40:31',
          propertyId: 10,
          name: 'Property Example',
          updatedAt: '2024-07-17 16:40:31',
          description: 'Used to indicate legally required material properties',
          id: 15,
          lang: 'en',
        },
        clients: [67698],
        display: ['showInItemListing', 'showOnItemsPage', 'displayInOrderProcess'],
        groups: [
          {
            options: [
              {
                id: 10,
                updatedAt: '2024-06-10 09:10:33',
                type: 'surchargeType',
                createdAt: '2024-06-10 09:10:33',
                groupId: 6,
                value: 'flat',
              },
              {
                createdAt: '2024-06-10 09:10:33',
                id: 9,
                type: 'groupType',
                groupId: 6,
                value: 'none',
                updatedAt: '2024-06-10 09:10:33',
              },
            ],
            position: 0,
            names: {
              id: 8,
              groupId: 6,
              description: 'Properties for displaying product information',
              name: 'Product properties',
              createdAt: '2024-06-10 09:10:33',
              updatedAt: '2024-06-10 09:10:33',
              lang: 'en',
            },
            updatedAt: '2024-06-10 09:10:33',
            id: 6,
            createdAt: '2024-06-10 09:10:33',
          },
        ],
        id: 10,
        groupId: 6,
        position: 0,
        markup: 0,
        values: {
          id: 2,
          lang: 'en',
          value: 'Example 2',
          description: '',
        },
      },
    ],
  },
];
